import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80
    }
  },
  boxtitle: {
    display: 'flex',
    alignItems: 'center',
    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '1.5rem'
  },

  title: {
    fontSize: '1.8em',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    display: 'flex',
    alignItems: 'center',
    color: '#606060',
    marginLeft: '5%',
    marginTop: '0.7rem'
  },
  typography: {
    fontSize: '1em'
  },
  boxTable: {
    width: '95%',
    marginTop: '1.2rem',
    marginLeft: '5%'
  }
}))

export default useStyles
